export default __webpack_public_path__ + "static/pmdiquette-a72db4456b358642e91d153e0dd3b42f.png";